import {
  parseCheckoutPrefillFromSearch,
  mergeCheckoutUrlPrefillIntoFields,
  readPersistedPluginCheckoutPrefillSearch,
} from '../utils/checkoutUrlPrefill';

export const mergeMobileFirstPageOnePrefill = (
  search: string,
  fromServer: Record<string, unknown>
): Record<string, unknown> | null => {
  const persisted = readPersistedPluginCheckoutPrefillSearch();
  const persistedPrefill = parseCheckoutPrefillFromSearch(persisted);
  const livePrefill = parseCheckoutPrefillFromSearch(search);
  const hasUrlPrefill =
    Object.keys(persistedPrefill).length > 0 ||
    Object.keys(livePrefill).length > 0;

  if (!hasUrlPrefill && Object.keys(fromServer).length === 0) {
    return null;
  }

  const base = {
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    ...fromServer,
  };

  const merged = mergeCheckoutUrlPrefillIntoFields(persisted, base);
  return mergeCheckoutUrlPrefillIntoFields(search, merged);
};
